import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'BlogCard',
})(({ spacing, aspectRatio, breakpoints, typography }) => ({
  blogCard: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    borderRadius: typography.pxToRem(16),
    overflow: 'hidden',
    aspectRatio: aspectRatio['16/9'],
    display: 'flex',
    '& > img': {
      objectFit: 'cover',
      maxWidth: '100%',
      display: 'block',
      width: '100%',
      height: 'auto',
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
  },
  textContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: `${typography.pxToRem(12)} 0 ${spacing(1)} 0`,
    [breakpoints.up('sm')]: {
      margin: `${spacing(0)} 0`,
    },
    [breakpoints.up('md')]: {
      margin: `${spacing(1)} 0`,
    },
  },
  title: {
    cursor: 'pointer',
    marginBottom: spacing(-1),
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    textDecoration: 'none',
    // This is needed to handle lowercase g on bottom rows of the title. The bottom part of the g was getting cut off
    paddingBottom: '.1rem',

    '&:hover': {
      textDecoration: 'underline',
    },
  },
  metadata: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  blogTag: {
    marginTop: 'auto',
  },
}));

export default useStyles;
